import { IntlShape } from 'react-intl';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import View from './View';
import type { ViewProps } from './View';
// eslint-disable-next-line import/no-unresolved

interface EditProps extends ViewProps {
  block: string;
  onChangeBlock: (blockId: string, newData: any) => void;
  selected: boolean;
  intl: IntlShape;
  blocksConfig: any;
}

const Edit = (props: EditProps) => {
  const { data, content, onChangeBlock, block, selected, blocksConfig } = props;
  return (
    <>
      <View
        isEdit
        content={content}
        data={data}
        block={block}
        onChangeBlock={onChangeBlock}
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          onChangeField={(id: any, value: any) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          blocksConfig={blocksConfig}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
